import { memo, useMemo } from 'react';

import type { StaticDataChartWidgetData } from '@/features/_shared/widget-registry';

import { useMarketPreview } from '@/features/markets/api';

import { MarketPreviewShell } from './MarketPreviewWidget';
import { buildStaticDataChartTemplate } from './staticDataChartTemplate';

export const StaticDataChartPreviewWidget = memo(
  ({ data }: { data: StaticDataChartWidgetData }) => {
    const template = useMemo(() => buildStaticDataChartTemplate(data), [data]);
    const { data: previewData, isLoading } = useMarketPreview(template);

    return (
      <MarketPreviewShell
        previewData={previewData}
        isLoading={isLoading}
      />
    );
  }
);

StaticDataChartPreviewWidget.displayName = 'StaticDataChartPreviewWidget';
